import { T, Translate } from '../../i18n';
import { NumberInputState } from './number.input.state';

const RE_ANGLE = /^\s*[+-]?((\.\d+)|(\d+(\.\d+)?))°?$/;
export class LocationFieldInputState extends NumberInputState {
	constructor(label: string, precision: number = 6, minimumInputPrecision: number = 0) {
		super(label, precision, minimumInputPrecision);
		this.isLabelShown = false;
		this.isErrorShown = false;
	}
}

export class LocationFieldAngleInputState extends LocationFieldInputState {
	maxValue: number;

	constructor(label: string, precision: number = 6, minimumInputPrecision: number = 0, maxValue: number = 0) {
		super(label, precision, minimumInputPrecision);
		this.isLabelShown = false;
		this.isErrorShown = false;
		this.maxValue = maxValue;
	}

	override parseInputValue(val: string): number {
		if (val.match(RE_ANGLE) == null) {
			this.setError(T.NUMBER_INVALID);
			return NaN;
		}

		//if the input value is a valid angle, we remove the potential '°' character and then manage it as a regular number
		val = val.split('°').join('');
		let res = super.parseInputValue(val);

		if (this.maxValue !== 0 && Math.abs(res) > this.maxValue) {
			this.setError(
				Translate(T.LOCATION_FIELD_OUT_OF_RANGE, { field: Translate(this.label), maxValue: this.maxValue })
			);
			return null;
		}

		return res;
	}
}
